var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 387,
    height: 178,
    viewBox: "0 0 387 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2303_11912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 284.399C-129.219 255.443 -84.823 237.273 -35.7998 254.912C7.85011 270.626 41.7816 307.133 75.3316 337.549C113.144 371.832 160.907 432.699 218.952 420.735C251.623 413.997 280.363 388.974 304.775 367.667C358.658 320.624 405.89 266.129 454.333 213.709C499.674 164.625 549.925 129.313 592.215 197.63C620.69 243.612 642.797 316.342 707.376 318.898C764.691 321.171 807.761 275.372 859.421 258.48C938.66 232.577 1019.04 308.709 1074.39 353.43",
    stroke: "url(#paint0_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 268.436C-128.158 236.244 -82.1529 214.871 -29.9953 233.423C14.0195 249.071 50.4718 284.748 83.0102 316.824C116.842 350.194 162.25 415.74 217.642 404.556C248.638 398.3 275.902 373.226 298.755 352.882C351.012 306.336 397.681 253.269 444.896 201.778C488.131 154.635 538.913 111.657 581.8 179.659C609.86 224.147 631.171 295.152 694.54 296.032C751.357 296.812 798.739 255.543 851.792 241.405C934.365 219.385 1015.06 291.568 1074.37 337.682",
    stroke: "url(#paint1_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 250.648C-123.896 214.788 -75.287 195.506 -19.5969 220.397C26.4577 240.99 66.7907 279.952 102.43 314.451C134.405 345.415 174.025 397.669 224.441 381.391C255.205 371.451 281.955 344.901 304.908 323.561C350.913 280.799 393.667 234.485 437.068 189.117C478.43 145.857 528.614 103.775 573.076 164.094C604.702 207.006 624.836 275.638 687.972 278.774C744.21 281.562 798.589 244.441 852.804 234.485C934.796 219.418 1011.05 275.97 1074.39 319.545",
    stroke: "url(#paint2_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 230.884C-120.463 193.482 -70.5439 177.037 -13.3115 206.574C30.5374 229.192 71.0031 265.615 107.074 298.853C140.69 329.834 181.969 383.216 232.766 359.586C259.285 347.257 281.11 323.777 301.94 303.914C345.755 262.097 387.199 217.759 429.987 174.913C474.25 130.591 524.401 96.2251 570.323 155.15C601.933 195.722 624.703 259.592 684.639 262.247C739.782 264.703 794.56 238.269 848.376 229.474C931.446 215.9 1005.2 258.281 1074.39 299.118",
    stroke: "url(#paint3_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 209.511C-112.95 168.724 -59.051 159.497 1.11687 197.447C44.3521 224.711 84.3203 261.649 123.011 294.953C155.318 322.764 191.654 366.423 236.863 341.134C261.076 327.593 281.226 303.449 300.513 283.918C341.576 242.317 381.561 199.704 423.817 159.298C467.6 117.432 517.718 87.2144 564.32 140.116C599.114 179.609 623.211 242.599 682.997 248.308C735.685 253.336 793.1 232.726 844.926 224.695C927.748 211.868 1000.62 241.156 1074.35 276.916",
    stroke: "url(#paint4_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 186.927C-108.24 145.725 -51.9529 141.311 9.39245 184.422C55.6792 216.946 97.2726 258.048 141.287 293.692C171.554 318.185 205.037 351.771 242.866 323.627C267.875 305.026 288.291 276.999 309.054 254.166C344.163 215.585 380.151 177.518 418.776 142.439C466.107 99.4443 517.436 79.1334 565.099 130.956C599.993 168.89 626.726 228.097 684.058 234.518C738.322 240.592 796.997 226.338 850.747 218.953C929.788 208.101 1000.14 225.773 1074.37 253.269",
    stroke: "url(#paint5_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 163.48C-99.6659 119.821 -40.3439 124.468 23.7213 175.643C72.3299 214.473 113.757 259.658 164.422 296.297C199.183 321.42 224.242 335.608 255.968 300.595C309.883 241.089 353.55 173.27 416.719 121.962C463.089 84.3104 514.102 70.272 560.306 114.096C599.346 151.117 625.615 207.951 681.969 221.293C733.994 233.589 799.286 221.459 851.593 214.323C928.793 203.786 998.464 209.976 1074.39 228.694",
    stroke: "url(#paint6_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 139.568C-91.3074 93.9516 -27.6735 108.77 38.216 167.164C85.4149 208.997 124.67 257.434 178.237 291.8C217.559 317.04 238.256 321.503 265.156 281.313C307.777 217.642 350.681 152.561 412.772 105.601C462.973 67.6172 513.837 59.0879 562.894 102.879C603.741 139.352 632.813 198.028 690.576 210.938C741.805 222.388 801.591 216.945 853.235 209.91C928.212 199.688 998.646 195.075 1074.39 203.521",
    stroke: "url(#paint7_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 115.573C-84.2757 68.5298 -17.64 91.7115 49.8747 156.079C97.6541 201.629 137.042 257.268 195.866 289.56C239.533 313.538 254.857 301.076 275.687 259.973C308.822 194.61 350.731 128.55 412.109 85.97C464.068 49.9115 516.623 48.7998 565.431 90.2346C608.003 126.393 639.015 183.542 696.049 199.572C818.375 233.954 951.497 182.563 1074.39 178.298",
    stroke: "url(#paint8_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 91.8605C-127.08 69.2763 -87.2443 55.8684 -39.8298 72.313C-0.607888 85.9199 31.5159 114.478 60.2897 143.567C107.754 191.59 148.336 256.206 211.572 284.748C259.003 306.154 270.23 277.314 286.234 237.073C312.321 171.428 351.709 104.173 413.253 65.7418C547.387 -18.0407 595.797 151.482 702.517 188.238C827.148 231.166 952.508 177.004 1074.39 153.391",
    stroke: "url(#paint9_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 68.8116C-125.255 45.4143 -84.5244 32.3715 -36.2475 50.1435C4.25132 65.0448 36.9887 95.4946 66.3264 126.343C112.464 174.846 160.177 258.811 229.002 278.127C277.179 291.651 284.775 246.549 296.981 210.241C318.341 146.687 355.159 76.6108 416.753 42.9916C544.618 -26.8022 609.014 130.126 705.552 174.481C832.206 232.676 954.847 173.005 1074.37 129.23",
    stroke: "url(#paint10_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 46.8247C-124.824 22.5313 -84.624 9.33917 -35.5013 26.547C5.22979 40.8177 38.5145 72.6614 67.4707 103.692C114.454 154.054 164.821 249.718 237.874 263.989C287.528 273.696 294.493 224.064 305.339 186.794C323.963 122.858 357.497 52.085 421.861 22.3488C549.908 -36.8084 618.965 113.847 713.413 162.567C762.585 187.922 826.252 200.915 881.03 192.087C950.469 180.903 1013.97 139.734 1074.39 106.33",
    stroke: "url(#paint11_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 26.2485C-121.922 -1.24754 -75.9835 -17.0947 -23.3616 6.66773C16.1257 24.5061 47.4534 57.2956 75.7628 89.1227C118.185 136.813 171.653 237.289 243.015 244.823C296.732 250.498 303.515 191.806 315.024 152.179C332.819 90.9314 364.86 25.2695 429.357 1.63979C556.442 -44.9392 629.927 94.7314 721.622 149.309C767.958 176.888 828.524 195.771 882.722 189.018C955.328 179.957 1018.17 127.388 1074.35 84.9908",
    stroke: "url(#paint12_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 7.48098C-124.576 -21.1268 -80.3949 -41.0395 -27.3749 -19.6168C15.114 -2.44213 48.946 34.0146 78.1344 68.0818C119.86 116.785 172.333 216.779 246.465 218.538C299.319 219.783 309.104 160.244 321.575 120.485C340.863 59.0547 371.361 -0.533836 439.009 -17.9076C568.549 -51.1949 640.475 76.5115 733.164 137.776C778.539 167.778 839.055 192.519 894.331 184.538C966.622 174.083 1024.7 113.964 1074.37 65.742",
    stroke: "url(#paint13_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 -9.09626C-128.257 -38.9818 -85.4697 -64.022 -33.0799 -46.4657C7.7506 -32.7923 39.9076 0.694116 67.3877 32.4548C112.398 84.46 157.673 176.971 235.155 182.878C294.062 187.359 309.369 130.077 326.318 84.7587C349.437 22.9299 381.66 -29.4238 452.459 -38.9984C577.969 -55.9739 650.293 52.0024 737.493 119.971C781.209 154.038 840.398 186.662 897.598 181.086C973.471 173.685 1029.31 103.095 1074.37 48.9823",
    stroke: "url(#paint14_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 -22.1723C-128.456 -50.7967 -86.1829 -74.36 -34.8379 -57.6334C5.14687 -44.6072 36.9721 -12.5976 64.1206 18.2006C107.853 67.7831 154.14 162.965 229.4 165.571C287.594 167.579 307.512 116.005 328.375 70.6704C355.125 12.5752 391.329 -40.6081 459.988 -49.8841C581.103 -66.2456 656.761 34.6285 742.717 99.1455C784.891 130.79 844.379 162.982 898.543 161.92C974.267 160.427 1030.36 88.3595 1074.37 35.7569",
    stroke: "url(#paint15_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 -31.1163C-129.103 -58.7451 -87.4433 -81.6612 -37.1099 -66.4281C1.78024 -54.663 33.1412 -24.6945 59.8585 4.64346C102.895 51.9194 148.982 146.106 221.804 146.554C278.904 146.903 303.216 101.435 328.143 57.1465C358.591 3.05045 398.56 -48.8552 464.781 -57.9486C581.518 -73.9617 660.376 16.5081 746.382 76.7272C788.141 105.966 846.982 138.589 898.659 143.202C974.002 149.923 1031 77.1421 1074.35 26.4312",
    stroke: "url(#paint16_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 -36.6586C-130.745 -63.1258 -89.3671 -86.0088 -41.0238 -73.7293C0.188158 -63.2752 32.9256 -32.0953 60.9862 -1.91106C103.641 43.971 146.412 129.197 217.675 126.028C271.59 123.638 299.07 82.6845 327.231 42.378C361.809 -7.13811 403.552 -53.5678 466.87 -62.5616C581.849 -78.9066 662.399 -0.699711 751.855 55.0889C793.183 80.8757 845.623 111.458 893.236 123.787C970.419 143.767 1029.19 71.4006 1074.37 20.2915",
    stroke: "url(#paint17_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 -39.5128C-131.806 -65.5817 -91.3074 -88.9625 -43.7602 -79.2883C-4.17351 -71.2236 28 -43.4787 55.5797 -15.6176C98.8316 28.0575 139.098 106.497 208.139 103.427C260.512 101.104 292.005 66.6216 324.046 29.468C362.439 -15.0368 406.752 -57.318 467.633 -66.1791C577.753 -82.2088 662.134 -19.6831 752.634 30.0653C797.545 54.757 844.777 84.9413 891.926 104.92C967.832 137.096 1027.5 67.4679 1074.35 16.6741",
    stroke: "url(#paint18_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 -40.3923C-90.246 -96.5791 -21.7363 -96.2971 50.1898 -29.6727C94.3538 11.2312 131.884 81.4399 198.503 79.0504C249.168 77.225 284.393 49.281 320.099 16.4749C362.174 -22.1722 408.527 -59.5582 466.986 -68.2534C571.915 -83.8682 660.757 -38.65 752.071 4.2452C802.338 27.8583 843.002 57.4783 889.82 86.2023C963.753 131.553 1024.1 66.8041 1074.39 14.9482",
    stroke: "url(#paint19_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 -40.0107C-95.7354 -94.0403 -27.889 -104.528 45.115 -44.3914C90.4399 -7.05524 125.35 54.1098 189.266 52.8486C295.687 50.7578 361.228 -53.5347 465.245 -69.2657C564.884 -84.3329 658.485 -57.6168 750.13 -22.222C806.152 -0.583634 841.427 30.0652 886.868 67.4512C958.147 126.094 1018.73 68.7289 1074.37 14.3508",
    stroke: "url(#paint20_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 -39.0813C-102.037 -90.4891 -34.7218 -112.26 38.9125 -61.3336C84.4364 -29.8551 117.821 22.7475 176.645 24.772C282.42 28.4392 361.129 -54.4638 462.641 -70.3109C555.265 -84.7642 654.256 -76.7493 743.613 -49.9336C807.23 -30.8341 839.719 3.89687 884.563 50.2601C901.313 67.5841 920.152 85.6217 945.311 88.3431C995.362 93.7361 1042.18 44.1038 1074.37 14.3012",
    stroke: "url(#paint21_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 -38.3182C-106.731 -88.0667 -39.7303 -119.678 35.5459 -78.0274C82.1146 -52.2571 114.504 -8.51565 170.045 -5.27985C273.381 0.743728 360.432 -54.6632 459.839 -70.1121C549.012 -83.968 650.06 -95.5173 739.118 -76.4012C807.628 -61.699 838.441 -20.6956 879.969 31.7079C895.873 51.7865 913.883 74.8851 940.17 81.1908C990.951 93.3707 1041.05 43.307 1074.35 14.1184",
    stroke: "url(#paint22_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 -38.4511C-108.24 -88.8964 -40.2112 -127.942 38.5974 -94.2894C81.5673 -75.9366 113.542 -42.3009 161.354 -37.6214C264.111 -27.5489 357.547 -54.879 457.882 -69.6144C510.752 -77.3803 562.844 -85.0798 615.267 -95.6501C656.014 -103.864 695.618 -108.129 737.045 -102.188C808.623 -91.9331 838.856 -40.7576 875.972 14.9978C890.831 37.3165 908.693 65.0283 935.692 73.906C987.435 90.9313 1039.05 42.4772 1074.37 13.0563",
    stroke: "url(#paint23_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 -40.1765C-110.495 -90.3232 -42.4335 -136.786 38.1496 -115.297C80.8708 -103.897 115.35 -77.38 159.746 -71.7712C261.026 -58.994 354.86 -56.09 456.057 -70.1948C509.641 -77.6621 559.875 -88.6638 610.988 -106.386C650.342 -120.026 688.105 -131.21 730.295 -128.224C805.422 -122.914 835.937 -62.4621 869.852 -3.75298C884.297 21.254 901.744 53.4295 929.738 65.5928C982.476 88.5089 1036.82 40.3535 1074.4 10.5343",
    stroke: "url(#paint24_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 -44.2089C-111.325 -94.8202 -43.528 -146.51 38.017 -138.678C81.7995 -134.48 121.867 -113.77 165.335 -107.365C264.691 -92.7128 352.09 -59.2761 454.15 -71.7381C508.149 -78.3425 556.674 -92.4473 605.333 -116.575C641.984 -134.745 676.91 -153.131 718.902 -153.662C800.53 -154.658 831.36 -83.3206 864.23 -20.3967C878.426 6.78405 895.492 42.1456 924.415 56.715C978.081 83.763 1034.67 36.122 1074.37 5.80501",
    stroke: "url(#paint25_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 -51.2615C-110.131 -103.516 -42.1516 -158.574 40.1895 -164.017C84.5857 -166.954 131.32 -153.745 174.522 -144.785C271.69 -124.64 352.588 -63.3584 455.775 -74.5095C508.829 -80.2344 555.679 -97.5086 600.158 -126.647C636.047 -150.161 668.933 -175.367 713.495 -177.972C796.898 -182.834 827.446 -99.9811 857.878 -37.1069C872.34 -7.25456 888.941 28.8537 918.759 46.5262C972.31 78.2537 1034.05 28.1236 1074.37 -1.7454",
    stroke: "url(#paint26_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 -62.0808C-67.9401 -151.289 39.0452 -220.071 177.242 -186.651C275.62 -162.855 351.394 -70.3114 458.13 -79.0398C512.212 -83.4703 557.769 -105.192 598.915 -139.591C631.138 -166.523 659.845 -196.06 703.81 -200.822C787.66 -209.899 818.391 -125.038 847.132 -62.2468C862.82 -27.9804 879.803 14.8815 913.85 35.292C968.744 68.1976 1032.49 17.6361 1074.35 -12.8302",
    stroke: "url(#paint27_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 -76.7828C-71.7711 -160.283 53.8881 -252.645 190.543 -214.346C286.466 -187.464 358.94 -85.0963 464.366 -90.5059C517.088 -93.2107 561.882 -118.483 599.097 -154.293C628.617 -182.685 655.003 -214.711 698.42 -219.523C778.854 -228.467 811.591 -144.701 839.934 -85.1461C856.9 -49.5191 874.678 -5.91039 909.572 16.0101C965.444 51.1061 1029.97 3.18304 1074.35 -27.7479",
    stroke: "url(#paint28_linear_2303_11912)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.453 -92.1485C-71.4228 -172.098 57.2713 -260.377 191.77 -227.223C290.629 -202.863 368.94 -101.275 475.975 -108.228C524.484 -111.381 565.132 -134.961 599.197 -168.215C626.378 -194.748 650.21 -224.982 689.896 -231.471C769.053 -244.414 808.159 -158.541 838.873 -101.59C856.518 -68.9005 875.657 -31.0167 907.681 -9.92592C963.686 26.9622 1026.71 -13.8753 1074.37 -44.5739",
    stroke: "url(#paint29_linear_2303_11912)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2303_11912",
    x1: 452.467,
    y1: 159.64,
    x2: 452.467,
    y2: 422.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2303_11912",
    x1: 452.459,
    y1: 144.343,
    x2: 452.459,
    y2: 405.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2303_11912",
    x1: 452.467,
    y1: 134.04,
    x2: 452.467,
    y2: 384.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2303_11912",
    x1: 452.467,
    y1: 123.816,
    x2: 452.467,
    y2: 365.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2303_11912",
    x1: 452.45,
    y1: 111.894,
    x2: 452.45,
    y2: 348.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2303_11912",
    x1: 452.459,
    y1: 100.169,
    x2: 452.459,
    y2: 334.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2303_11912",
    x1: 452.467,
    y1: 86.9336,
    x2: 452.467,
    y2: 321.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2303_11912",
    x1: 452.467,
    y1: 73.4302,
    x2: 452.467,
    y2: 311.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2303_11912",
    x1: 452.467,
    y1: 59.0303,
    x2: 452.467,
    y2: 301.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2303_11912",
    x1: 452.467,
    y1: 42.7617,
    x2: 452.467,
    y2: 292.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2303_11912",
    x1: 452.459,
    y1: 25.3584,
    x2: 452.459,
    y2: 280.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2303_11912",
    x1: 452.467,
    y1: 8.79004,
    x2: 452.467,
    y2: 265.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2303_11912",
    x1: 452.45,
    y1: -7.7168,
    x2: 452.45,
    y2: 245.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2303_11912",
    x1: 452.459,
    y1: -28.6226,
    x2: 452.459,
    y2: 218.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2303_11912",
    x1: 452.459,
    y1: -52.2788,
    x2: 452.459,
    y2: 183.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2303_11912",
    x1: 452.459,
    y1: -63.2095,
    x2: 452.459,
    y2: 165.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2303_11912",
    x1: 452.45,
    y1: -71.2988,
    x2: 452.45,
    y2: 146.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2303_11912",
    x1: 452.459,
    y1: -77.1372,
    x2: 452.459,
    y2: 127.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2303_11912",
    x1: 452.45,
    y1: -81.5181,
    x2: 452.45,
    y2: 113.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2303_11912",
    x1: 452.467,
    y1: -81.1792,
    x2: 452.467,
    y2: 101.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2303_11912",
    x1: 452.459,
    y1: -85.1938,
    x2: 452.459,
    y2: 92.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2303_11912",
    x1: 452.459,
    y1: -90.3081,
    x2: 452.459,
    y2: 88.7488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2303_11912",
    x1: 452.45,
    y1: -97.3145,
    x2: 452.45,
    y2: 83.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2303_11912",
    x1: 452.459,
    y1: -106.873,
    x2: 452.459,
    y2: 77.4401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2303_11912",
    x1: 452.475,
    y1: -128.71,
    x2: 452.475,
    y2: 71.5815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2303_11912",
    x1: 452.459,
    y1: -153.672,
    x2: 452.459,
    y2: 64.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2303_11912",
    x1: 452.459,
    y1: -178.177,
    x2: 452.459,
    y2: 56.6734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2303_11912",
    x1: 452.45,
    y1: -201.494,
    x2: 452.45,
    y2: 46.0107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2303_11912",
    x1: 452.45,
    y1: -223.266,
    x2: 452.45,
    y2: 28.3291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2303_11912",
    x1: 452.459,
    y1: -234.384,
    x2: 452.459,
    y2: 4.70874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2303_11912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1245,
    height: 832,
    fill: "white",
    transform: "translate(-170 -278)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBox);
export default __webpack_public_path__ + "static/media/card-box.b6948ae23cf92e3ffa4136c0c7de1a4d.svg";
export { ForwardRef as ReactComponent };